import * as React from "react";

const hasNumberRegex = "\\d";
const hasCapitalRegex = "[A-Z]";
const hasSpecialCharacter = "(?=.*?[#?!@$%^&*-])";

export const validateLengthPasswordConstraint = (password: string) =>
  password.length >= 8;
export const validateConfirmation = (password: string, confirmation: string) =>
  validateLengthPasswordConstraint(password) && password === confirmation;
export function validateExtraPasswordConstraints(
  password: string,
): { satisfied: boolean; reason: string }[] {
  return [
    {
      // hasNumber
      satisfied: password.match(hasNumberRegex) != null,
      reason: "Must have a number",
    },
    {
      satisfied: password.match(hasCapitalRegex) != null,
      reason: "Must have a capital letter",
    },
    {
      satisfied: password.match(hasSpecialCharacter) != null,
      reason: "Must have a special character",
    },
  ];
}
export const validateAllPasswordConstraints = (
  password: string,
  confirmation: string,
) => {
  const hasLength = validateLengthPasswordConstraint(password);
  const extraRequirements = validateExtraPasswordConstraints(password);
  const hasExtraRequirements =
    extraRequirements.reduce((sum, r) => sum + (r.satisfied ? 1 : 0), 0) >= 2;
  const hasSameConfirmation = validateConfirmation(password, confirmation);
  return hasLength && hasExtraRequirements && hasSameConfirmation;
};

interface IPasswordValidatorProps {
  password: string;
  confirmation: string;
}

const dulledColor = "lightgray";

export const PasswordValidator: React.FunctionComponent<
  IPasswordValidatorProps
> = ({ password, confirmation }) => {
  const hasLength = validateLengthPasswordConstraint(password);
  const extraRequirements = validateExtraPasswordConstraints(password);
  const hasExtraRequirements =
    extraRequirements.reduce((sum, r) => sum + (r.satisfied ? 1 : 0), 0) >= 2;
  const hasSameConfirmation = validateConfirmation(password, confirmation);

  if (hasLength && hasExtraRequirements && hasSameConfirmation) {
    return (
      <p style={{ color: "green", textAlign: "center" }}>
        All password constraints have been met!
      </p>
    );
  }

  return (
    <div>
      <ul>
        <li style={{ color: hasLength ? dulledColor : "black" }}>
          Password has length with eight (8) or more characters
        </li>
        <li style={{ color: hasExtraRequirements ? dulledColor : "black" }}>
          {" "}
          Must satisfy two (2) of the following three (3) requirements:
          <ul>
            {extraRequirements.map((r, idx) => (
              <li
                key={idx}
                style={{ color: r.satisfied ? dulledColor : "black" }}
              >
                {r.reason}
              </li>
            ))}
          </ul>
        </li>
        <li style={{ color: hasSameConfirmation ? dulledColor : "black" }}>
          Confirmation password must match
        </li>
      </ul>
    </div>
  );
};
